import {normalizeActionHandler} from './normalizeActionHandler';

export function normalizeActionHandlers(actionHandlers, tagName) {
	const normalizedActionHandlers = {};

	for (const k in actionHandlers)
		normalizedActionHandlers[k] = normalizeActionHandler(actionHandlers[k], tagName);

	return normalizedActionHandlers;
}
